<template>
  <div>
    <el-dialog :visible.sync="selectDialogVisibleValue" @close="closeSelectDialog" width="600px"
               :close-on-click-modal="false"
               title="养老">
      <div class='radioDiv'>
        <el-radio v-model="radio" label="0">社保</el-radio>
        <el-radio v-model="radio" label="1">补充养老储蓄福利</el-radio>
        <el-radio v-model="radio" label="2">个人养老金产品</el-radio>
        <el-radio v-if='hasInsure' v-model="radio" label="3">大都会保险产品</el-radio>
      </div>

      <div slot="footer">
        <el-button type="primary" @click="selectConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if='radio==="0"'
               :visible.sync="dialogVisibleValue" @close="closeDialog" width="900px"
               :close-on-click-modal="false"
               title="社保">
      <div class='dialogBody'>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>城市：</span>
          </el-col>
          <el-col :span='18'>
            <el-select v-model="city" placeholder="请选择" size='small' style='width: 200px'>
              <el-option v-for="item in cities" :key="item.name" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>实际缴费年限：</span>
          </el-col>
          <el-col :span='18'>
            <el-input-number v-model="currentSocialSecurityPaidYears" :min="0" :max="50" size='small' style='width: 200px'></el-input-number>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>当前个人账户余额：</span>
            <el-tooltip effect="dark" :content="currentAccountBalanceP1Tooltip" placement="top-start">
              <i class="el-icon-warning ml-5"></i>
            </el-tooltip>
          </el-col>
          <el-col :span='18'>
            <el-input v-model="currentAccountBalanceP1" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if='radio==="1"'
               :visible.sync="dialogVisibleValue" @close="closeDialog" width="900px"
               :close-on-click-modal="false"
               title="补充养老储蓄福利">
      <div class='dialogBody'>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>当前余额：</span>
          </el-col>
          <el-col :span='18'>
            <el-input v-model="currentAccountBalanceP2" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row v-if='hasP2Corporation' :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>是否税优：</span>
          </el-col>
          <el-col :span='18'>
            <el-checkbox v-model='isCorporationP2'></el-checkbox>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>缴费比例(企业)：</span>
          </el-col>
          <el-col :span='18'>
            <el-input v-model="formatEmployerContributionRatioP2" @change='p2InputChange(0)' size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>缴费比例(个人)：</span>
          </el-col>
          <el-col :span='18'>
            <el-input v-model="formatEmployeeContributionRatioP2" @change='p2InputChange(1)' size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>退休后领取年数：</span>
            <el-tooltip effect="dark" :content="ReceivingYearsTooltip" placement="top-start">
              <i class="el-icon-warning ml-5"></i>
            </el-tooltip>
          </el-col>
          <el-col :span='18'>
            <el-input v-model="selectedReceivingYearsP2" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='24' class='spanCol'>
            <span class='f16 fb'>投资组合类型</span>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>稳健型投资组合</span>
          </el-col>
          <el-col :span='18'>
            <el-slider v-model='stableInvestmentPortfolioP2'  @change="sliderChange( 0)" :format-tooltip="handleDelta" style='width: 200px'></el-slider>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>平衡型投资组合</span>
          </el-col>
          <el-col :span='18'>
            <el-slider v-model='balancedInvestmentPortfolioP2'  @change="sliderChange(1)" :format-tooltip="handleDelta" style='width: 200px'></el-slider>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>多元型投资组合</span>
          </el-col>
          <el-col :span='18'>
            <el-slider v-model='diversifiedInvestmentPortfolioP2' @change="sliderChange(2)" :format-tooltip="handleDelta" style='width: 200px'></el-slider>
          </el-col>
        </el-row>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if='radio==="2"'
               :visible.sync="dialogVisibleValue" @close="closeDialog" width="900px"
               :close-on-click-modal="false"
               title="个人养老金产品">
      <div class='dialogBody'>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>商业养老(税优)每月缴费：</span>
            <el-tooltip effect="dark" :content="actualMonthlyContributionP3Tooltip" placement="top-start">
              <i class="el-icon-warning ml-5"></i>
            </el-tooltip>
          </el-col>
          <el-col :span='18'>
            <el-input v-model="actualMonthlyContributionP3" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>当前余额：</span>
          </el-col>
          <el-col :span='18'>
            <el-input v-model="currentAccountBalanceP3" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>领取年数：</span>
            <el-tooltip effect="dark" :content="ReceivingYearsTooltip" placement="top-start">
              <i class="el-icon-warning ml-5"></i>
            </el-tooltip>
          </el-col>
          <el-col :span='18'>
            <el-input v-model="selectedReceivingYearsP3" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>投资类型：</span>
          </el-col>
          <el-col :span='18'>
            <el-select v-model="portfolioPreferenceP3" placeholder="请选择" size='small' style='width: 200px'>
              <el-option v-for="item in portfolioPreferenceOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if='radio==="3"'
               :visible.sync="dialogVisibleValue" @close="closeDialog" width="900px"
               :close-on-click-modal="false"
               title="大都会保险产品">
      <div class='dialogBody'>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>保险产品：</span>
          </el-col>
          <el-col :span='18'>
            <el-select v-model="insureProductId" placeholder="请选择" size='small' style='width: 200px'>
              <el-option v-for="item in insureProduceOptions" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
            <a class="inline-block" style='color: #e90a5b; margin-left: 10px' @click='openAddInsureDialog'>添加</a>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>起始领取年龄：</span>
          </el-col>
          <el-col :span='18'>
            <el-input-number v-model="startingAgeForBenefitCollectionB1" :min="55" :max="105" size='small' style='width: 200px'></el-input-number>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>年缴费金额：</span>
          </el-col>
          <el-col :span='18'>
            <el-input :class='annualDisabled ? "inputDisabled": ""' v-model="annualContributionAmountB1" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>基础保额：</span>
          </el-col>
          <el-col :span='18'>
            <el-input :class='pensionDisabled ? "inputDisabled": ""' v-model="pensionBenefitAmountB1" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>已缴费年限：</span>
          </el-col>
          <el-col :span='18'>
            <el-input v-model="yearsOfContributionsMadeB1" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>总缴费年限：</span>
          </el-col>
          <el-col :span='18'>
            <el-input v-model="totalContributionPeriodB1" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" type='flex' justify='center' style='margin: 20px 0'>
          <el-col :span='6' class='spanCol'>
            <span>保障年龄：</span>
          </el-col>
          <el-col :span='18'>
            <el-input :disabled='insureProductId !== 1' v-model="coverageAgeB1" size='small' style='width: 200px'></el-input>
          </el-col>
        </el-row>
        <el-row style='margin-top: 40px'>
          <el-col :span='24'>
            <i class="el-icon-warning ml-5"></i><span>用户正在积极贡献该产品的数据，图中展示数据是基于已有数据的插值估算结果，存在一定误差，仅供参考。</span>
          </el-col>
        </el-row>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="uploadDialogVisibleValue" width="60%" class="addInsureDialog" title='添加建议书'>
      <div v-for='item in insureCashTableUrls' class="mb15 ">
        <span class="fb inline-block" style='width: 20%'>建议书链接地址</span>
        <el-input v-model="item.url" class="rad20" style='width: 70%'></el-input>
      </div>
      <div style='text-align: center'>
        <el-button @click='urlAdd' style='width: 200px'>+</el-button>
      </div>
      <div slot="footer" class="ac">
        <el-button type="info" @click="closeAddInsureCashTableDialog"> 取消</el-button>
        <el-button type="primary" @click="addInsureCashTable"> 添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PensionDialog',
  props: ['dialogVisible', 'params', 'gender', 'retirementAge'],
  computed: {
    token () {
      return this.$store.getters.getToken
    },
  },
  mounted() {
    // 获取环境变量
    const url = this.$api.SupportCities
    this.hasP2Corporation = window._env_.has_p2_corporation || false
    this.hasInsure = window._env_.has_insure || false

    this.getToken = this.token === '' ? localStorage.getItem('token') : this.token
    this.$http.post(url, {}, {Authorization: `Bearer ${this.getToken}`}, window._env_.api_url, res => {
      this.cities = res.data
    })
    this.getInsureProductList()
  },
  watch: {
    dialogVisible (val) {
      this.selectDialogVisibleValue = val
      if (val) {
        this.city = this.params[this.publicPensionIndex]["CITY"]
        this.currentSocialSecurityPaidYears = this.params[this.publicPensionIndex]["CURRENT_SOCIAL_SECURITY_PAID_YEARS"]
        this.currentAccountBalanceP1 = this.params[this.publicPensionIndex]["CURRENT_ACCOUNT_BALANCE_P1"]

        this.currentAccountBalanceP2 = this.params[this.enterpriseAnnuityIndex]["CURRENT_ACCOUNT_BALANCE_P2"]
        this.isCorporationP2 = this.hasP2Corporation ? this.params[this.enterpriseAnnuityIndex]["IS_CORPORATION_P2"] : false
        this.employerContributionRatioP2 = this.params[this.enterpriseAnnuityIndex]["MONTHLY_EMPLOYER_CONTRIBUTION_RATIO_P2"] * 100
        this.formatEmployerContributionRatioP2 = this.employerContributionRatioP2 + '%'
        this.employeeContributionRatioP2 = this.params[this.enterpriseAnnuityIndex]["MONTHLY_EMPLOYEE_CONTRIBUTION_RATIO_P2"] * 100
        this.formatEmployeeContributionRatioP2 = this.employeeContributionRatioP2 + '%'
        this.selectedReceivingYearsP2 = this.params[this.enterpriseAnnuityIndex]["SELECTED_RECEIVING_YEARS_P2"]
        this.stableInvestmentPortfolioP2 = this.params[this.enterpriseAnnuityIndex]["STABLE_INVESTMENT_PORTFOLIO_P2"] * 100
        this.balancedInvestmentPortfolioP2 = this.params[this.enterpriseAnnuityIndex]["BALANCED_INVESTMENT_PORTFOLIO_P2"] * 100
        this.diversifiedInvestmentPortfolioP2 = this.params[this.enterpriseAnnuityIndex]["DIVERSIFIED_INVESTMENT_PORTFOLIO_P2"] * 100

        this.actualMonthlyContributionP3 = this.params[this.privatePensionIndex]["ACTUAL_MONTHLY_CONTRIBUTION_P3"]
        this.currentAccountBalanceP3 = this.params[this.privatePensionIndex]["CURRENT_ACCOUNT_BALANCE_P3"]
        this.selectedReceivingYearsP3 = this.params[this.privatePensionIndex]["SELECTED_RECEIVING_YEARS_P3"]
        this.portfolioPreferenceP3 = this.params[this.privatePensionIndex]["PORTFOLIO_PREFERENCE_P3"]

        this.insureProductId = this.params[this.insuranceProductIndex]["INSURANCE_PRODUCT_ID"]
        this.startingAgeForBenefitCollectionB1 = this.params[this.insuranceProductIndex]["STARTING_AGE_FOR_BENEFIT_COLLECTION_B1"]
        this.annualContributionAmountB1 = this.params[this.insuranceProductIndex]["ANNUAL_CONTRIBUTION_AMOUNT_B1"]
        this.pensionBenefitAmountB1 = this.params[this.insuranceProductIndex]["PENSION_BENEFIT_AMOUNT_B1"] ? this.params[this.insuranceProductIndex]["PENSION_BENEFIT_AMOUNT_B1"]: 0
        this.yearsOfContributionsMadeB1 = this.params[this.insuranceProductIndex]["YEARS_OF_CONTRIBUTIONS_MADE_B1"]
        this.totalContributionPeriodB1 = this.params[this.insuranceProductIndex]["TOTAL_CONTRIBUTION_PERIOD_B1"]
        this.coverageAgeB1 = this.params[this.insuranceProductIndex]["COVERAGE_AGE_B1"]
      }
    },
    params(val) {

    },
    annualContributionAmountB1(val) {
      if(val !== 0) {
        this.pensionBenefitAmountB1 = 0
        this.pensionDisabled = true
        this.annualDisabled = false
      }
    },
    pensionBenefitAmountB1(val) {
      if(val !== 0) {
        this.annualContributionAmountB1 = 0
        this.annualDisabled = true
        this.pensionDisabled = false
      }
    }
  },
  data() {
    return {
      publicPensionIndex: 2,
      enterpriseAnnuityIndex: 3,
      privatePensionIndex: 4,
      insuranceProductIndex: 5,
      getToken: '',
      selectDialogVisibleValue: false,
      dialogVisibleValue: false,
      uploadDialogVisibleValue: false,
      hasP2Corporation: true,
      hasInsure: false,
      radio: '0',

      // radio === 0
      city: '北京',
      cities: [],
      currentSocialSecurityPaidYears: 0,
      currentAccountBalanceP1: 0,
      currentAccountBalanceP1Tooltip: '可在支付宝查询社保养老金获得该信息',

      // radio === 1
      ReceivingYearsTooltip: '默认领取至平均预期寿命年龄',
      currentAccountBalanceP2: 0,
      isCorporationP2: false,
      employerContributionRatioP2: 0,
      formatEmployerContributionRatioP2: 0,
      employeeContributionRatioP2: 0,
      formatEmployeeContributionRatioP2: 0,
      selectedReceivingYearsP2: 20,
      stableInvestmentPortfolioP2: 50,
      balancedInvestmentPortfolioP2: 40,
      diversifiedInvestmentPortfolioP2: 10,

      // radio === 2
      actualMonthlyContributionP3Tooltip: '每年上限12000，超过部分自动参与税优计算',
      actualMonthlyContributionP3: 0,
      currentAccountBalanceP3: 0,
      selectedReceivingYearsP3: 20,
      portfolioPreferenceP3: '保险',
      portfolioPreferenceOptions: [
        {label: '养老保险型产品', value: '保险'},
        {label: '养老基金型产品', value: '基金'},
        {label: '养老理财型产品', value: '理财'},
        {label: '养老储蓄型产品', value: '储蓄'},
      ],

      // radio === 3
      insureProductId: 0,
      insureProduceOptions: [],
      startingAgeForBenefitCollectionB1: 60,
      annualContributionAmountB1: 0,
      pensionBenefitAmountB1: 0,
      yearsOfContributionsMadeB1: 0,
      totalContributionPeriodB1: 0,
      coverageAgeB1: 105,


      // upload
      insureCashTableUrls: [{'url': ''}],

      sliderObj: {
        lockIdx: 2,
        lastLockIdx: 0,
        objList: ['stableInvestmentPortfolioP2', 'balancedInvestmentPortfolioP2', 'diversifiedInvestmentPortfolioP2']
      },
      annualDisabled: false,
      pensionDisabled: false
    }
  },
  methods: {
    handleDelta (e) {
      return `${e}%`
    },
    sliderChange (idx) {
      const idxList = [0, 1, 2]
      let lockIdxList = [idx]
      let val = 100 - this[this.sliderObj.objList[idx]]
      let max_val
      if (this.sliderObj.lockIdx === idx){
        lockIdxList.push(this.sliderObj.lastLockIdx)
        val -= this[this.sliderObj.objList[this.sliderObj.lastLockIdx]]
        max_val = 100 - this[this.sliderObj.objList[this.sliderObj.lastLockIdx]]
      } else {
        lockIdxList.push(this.sliderObj.lockIdx)
        val -= this[this.sliderObj.objList[this.sliderObj.lockIdx]]
        max_val = 100 - this[this.sliderObj.objList[this.sliderObj.lockIdx]]
      }
      const changeIdx = idxList.filter(item => !lockIdxList.includes(item))[0]
      this[this.sliderObj.objList[changeIdx]] = val >= 0 ? val : 0
      if (this[this.sliderObj.objList[idx]] > max_val) {
        this[this.sliderObj.objList[idx]] = max_val
      }
      if (this.sliderObj.lockIdx !== idx) {
        this.sliderObj.lastLockIdx = this.sliderObj.lockIdx
        this.sliderObj.lockIdx = idx
      }
    },
    selectConfirm () {
      this.selectDialogVisibleValue = false
      this.dialogVisibleValue = true
    },
    confirm () {
      let data
      if (this.radio === '0') {
        data = {
          "CITY": this.city,
          "CURRENT_SOCIAL_SECURITY_PAID_YEARS": this.currentSocialSecurityPaidYears,
          "CURRENT_ACCOUNT_BALANCE_P1": this.currentAccountBalanceP1,
        }
      } else if (this.radio === '1') {
        data = {
          "CURRENT_ACCOUNT_BALANCE_P2": this.currentAccountBalanceP2,
          "IS_CORPORATION_P2": this.hasP2Corporation ? this.isCorporationP2 : false,
          "MONTHLY_EMPLOYER_CONTRIBUTION_RATIO_P2": this.employerContributionRatioP2 / 100,
          "MONTHLY_EMPLOYEE_CONTRIBUTION_RATIO_P2": this.employeeContributionRatioP2 / 100,
          "SELECTED_RECEIVING_YEARS_P2": this.selectedReceivingYearsP2,
          "STABLE_INVESTMENT_PORTFOLIO_P2": this.stableInvestmentPortfolioP2 / 100,
          "BALANCED_INVESTMENT_PORTFOLIO_P2": this.balancedInvestmentPortfolioP2 / 100,
          "DIVERSIFIED_INVESTMENT_PORTFOLIO_P2": this.diversifiedInvestmentPortfolioP2 / 100
        }
      } else if (this.radio === '2') {
        data = {
          "ACTUAL_MONTHLY_CONTRIBUTION_P3": this.actualMonthlyContributionP3,
          "CURRENT_ACCOUNT_BALANCE_P3": this.currentAccountBalanceP3,
          "SELECTED_RECEIVING_YEARS_P3": this.selectedReceivingYearsP3,
          "PORTFOLIO_PREFERENCE_P3": this.portfolioPreferenceP3
        }
      } else if (this.radio === '3') {
        data = {
          "component_type": 'PrivatePension' + this.insureProductId,
          "INSURANCE_PRODUCT_ID": this.insureProductId,
          "ANNUAL_CONTRIBUTION_AMOUNT_B1": this.annualContributionAmountB1,
          "PENSION_BENEFIT_AMOUNT_B1": this.pensionBenefitAmountB1 === 0 ? null : this.pensionBenefitAmountB1,
          "YEARS_OF_CONTRIBUTIONS_MADE_B1": this.yearsOfContributionsMadeB1,
          "TOTAL_CONTRIBUTION_PERIOD_B1": this.totalContributionPeriodB1,
          "COVERAGE_AGE_B1": this.coverageAgeB1
        }
        if (this.insureProductId === 1) {
          data["STARTING_AGE_FOR_BENEFIT_COLLECTION_B1"] = this.startingAgeForBenefitCollectionB1
        }
      }
      this.$emit('dialogConfirm', parseInt(this.radio)+2, data)
      this.closeDialog()
    },
    p2InputChange (val) {
      var input = 0
      if (val === 0) {
        // 修改企业缴费比例
        input = this.formatEmployerContributionRatioP2
        input = this.formatInput(input)
        this.formatEmployerContributionRatioP2 = input
        this.employerContributionRatioP2 = parseFloat(input.split('%')[0])
      } else if (val === 1) {
        // 修改个人缴费比例
        input = this.formatEmployeeContributionRatioP2
        input = this.formatInput(input)
        this.formatEmployeeContributionRatioP2 = input
        this.employeeContributionRatioP2 = parseFloat(input.split('%')[0])
      }
    },
    formatInput(input) {
      let res = ''
      if (typeof input === 'string' && input.indexOf('%') !== -1) {
        if (input.indexOf('%') !== input.length - 1) {
          res = input.replace('%', '')
        } else {
          res = input
        }
      } else {
        res = input + '%'
      }
      return res
    },
    closeSelectDialog () {
      this.selectDialogVisibleValue = false
      this.$emit('dialogVisibleChange', false)
    },
    closeDialog () {
      this.dialogVisibleValue = false
      this.$emit('dialogVisibleChange', this.dialogVisibleValue)
    },
    getInsureProductList () {
      const url = this.$api.InsureProductList
      this.$http.post(url, {}, {Authorization: `Bearer ${this.getToken}`}, window._env_.api_url, res => {
        if (res.status === 200){
          this.insureProduceOptions = res.data
        }
      })
    },
    openAddInsureDialog () {
      if(this.insureProductId !== -1) {
        this.uploadDialogVisibleValue = true
        this.dialogVisibleValue = false
      }
    },
    urlAdd () {
      this.insureCashTableUrls.push({'url': ''})
    },
    closeAddInsureCashTableDialog () {
      this.insureCashTableUrls = [{'url': ''}]
      this.uploadDialogVisibleValue = false
      this.dialogVisibleValue = true
    },
    addInsureCashTable () {
      const url = this.$api.InsureCashTableAdd
      let cashUrls = this.insureCashTableUrls.map( (item) => {
        return item.url
      })
      const params= {
        'urls': cashUrls,
        'insureId': this.insureProductId
      }
      this.$http.post(url, params, {Authorization: `Bearer ${this.getToken}`}, window._env_.api_url, res => {
        if (res.status === 200) {
          this.closeAddInsureCashTableDialog()
        }
      })
    },
  }
}
</script>

<style scoped>
.radioDiv {
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
}
.dialogBody {
  max-height: 460px;
}
.inputDisabled >>> .el-input__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
}
</style>



// WEBPACK FOOTER //
// src/components/options/PensionDialog.vue